module.exports = __webpack_public_path__ + "static/images/social-twitter.a1f238abfc368904e3339b8a98bb27cd.svg";